var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.model)?_c('v-text-field',_vm._b({on:{"input":_vm.inputChange},model:{value:(_vm.model.value),callback:function ($$v) {_vm.$set(_vm.model, "value", $$v)},expression:"model.value"}},'v-text-field',_vm.theProps,false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }